import { environment } from '@cpcac/common/environments/environment';

/** Init page analytics. */
export function initializeAnalytics(): void {
  const { googleAnalytics, baiduKey } = environment;
  const useGA = environment.country === 'US';
  const useBaidu = environment.country === 'CN';

  if (useGA && googleAnalytics) {
    initializeGoogleTagManagerScript(googleAnalytics);
    initializeGoogleAnalytics(googleAnalytics);
  }

  if (useBaidu && baiduKey) {
    initializeBaiduAnalytics(baiduKey);
  }
}

/**
 * Init Google Tag Manager script.
 * @param key  Google analytics key.
 */
function initializeGoogleTagManagerScript(key: string): void {
  const commentStart = document.createComment(' Google Tag Manager ');
  const commentEnd = document.createComment(' End Google Tag Manager ');
  const script = document.createElement('script');
  script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${key}');
    `;
  document.head.appendChild(commentStart);
  document.head.appendChild(script);
  document.head.appendChild(commentEnd);
}

/**
 * Init Google analytics.
 * @param key  Google analytics key.
 */
function initializeGoogleAnalytics(key: string): void {
  const commentStart = document.createComment(' Google Tag Manager (noscript) ');
  const commentEnd = document.createComment(' End Google Tag Manager (noscript) ');
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${key}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.prepend(commentEnd);
  document.body.prepend(noscript);
  document.body.prepend(commentStart);
}

/**
 * Init Baidu analytics.
 * @param key  Baidu analytics key.
 */
function initializeBaiduAnalytics(key: string): void {
  const script = document.createElement('script');
  script.innerHTML = `
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?${key}";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    `;
  document.head.appendChild(script);
}
